export type LocationPlanId = 'essential' | 'growth' | 'elite';

export type LocationPlan = {
  id: LocationPlanId;
  popular?: boolean;
  allowWhenActive?: boolean;
};

export const locationPlans: LocationPlan[] = [
  { id: 'essential', allowWhenActive: true },
  { id: 'growth', popular: true, allowWhenActive: true },
  { id: 'elite', allowWhenActive: true },
];
